import { useDispatch, useSelector } from "react-redux";
import PlanItemPaymentItem from "./Item";
import {
  getWalletInfo,
  paymentToWallet,
} from "../../../../../../redux/action/wallet/action";
import { useCookies } from "react-cookie";
import { useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MessageForPaymentWallet from "./Message";
import { checkBazaarSDK } from "../../../../../../redux/action/baseData/baseAction";
import ConfirmModal from "../../../../../UI/ConfirmModal";
import { ReactSVG } from "react-svg";

// از بین پلن‌های فعال، اونی که هنوز منقضی نشده و بیشترین زمان باقی‌مونده رو داره پیدا می‌کنه
const getRemainingPlanInfo = (activePlans) => {
  if (!Array.isArray(activePlans) || activePlans.length === 0) {
    return { hasRemainingPlan: false, remainingDays: 0 };
  }

  const now = new Date();

  const remainingList = activePlans
    .map((plan) => {
      const expireDate = plan?.pivot?.expire_date
        ? new Date(plan.pivot.expire_date.replace(" ", "T"))
        : null;

      if (!expireDate || isNaN(expireDate.getTime())) return null;

      const diffMs = expireDate.getTime() - now.getTime();
      const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

      return diffDays > 0 ? diffDays : null;
    })
    .filter((d) => d !== null);

  if (remainingList.length === 0) {
    return { hasRemainingPlan: false, remainingDays: 0 };
  }

  return {
    hasRemainingPlan: true,
    remainingDays: Math.max(...remainingList),
  };
};

const PlanItemPaymentItems = ({
  id,
  title,
  price,
  plan_code,
  last_purchase_token,
  last_purchase_date,
  onToggleActivePaymentItem = () => {},
}) => {
  const dispatch = useDispatch();
  const walletAmount = useSelector(
    (state) => state.wallet?.wallet?.balance?.total,
  );
  const walletLoading = useSelector((state) => state?.wallet.loading);
  const walletLoaded = useSelector((state) => state?.wallet.loaded);
  const cashBalance = useSelector(
    (state) => state?.baseData?.info?.wallet?.cash_balance,
  );
  const LOW_BALANCE_THRESHOLD = Number(cashBalance) || 3000;

  const activeUserPlan = useSelector(
    (state) => state.profile.profile.active_user_plan,
  );

  const { hasRemainingPlan, remainingDays } = useMemo(
    () => getRemainingPlanInfo(activeUserPlan),
    [activeUserPlan],
  );

  const [clickedButton, setClickedButton] = useState();

  const [paymentWithWalletStatusBalance, setPaymentWithWalletStatusBalance] =
    useState();
  const [showMessage, setShowMessage] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const [cookies] = useCookies(["authToken"]);

  const hasBazaarSDK = useSelector((state) => state.baseData.bazar_connection);

  const getWalletData = async () => {
    await dispatch(await getWalletInfo(cookies.authToken));
  };
  useEffect(() => {
    dispatch(checkBazaarSDK());
    if (!walletLoaded && !walletLoading) {
      getWalletData();
    }
  }, []);

  const isLowBalance = (walletAmount || 0) < LOW_BALANCE_THRESHOLD;

  // ---------- Confirm Modal (ساده - وقتی موجودی مشکلی نداره) ----------
  const [confirmModal, setConfirmModal] = useState({
    show: false,
    type: null, // 'direct' | 'wallet'
  });

  const closeConfirmModal = () => {
    setConfirmModal({ show: false, type: null });
    document.body.classList.remove("modal-opened");
  };

  const runPaymentByType = (type) => {
    if (type === "direct") {
      payment();
    } else if (type === "wallet") {
      paymentWithWallet();
    }
  };

  const handleGeneralConfirm = () => {
    const type = confirmModal.type;
    closeConfirmModal();
    runPaymentByType(type);
  };

  const confirmDescription = hasRemainingPlan
    ? `از اشتراک فعلی شما ${remainingDays.toLocaleString(
        "fa",
      )} روز از اشتراک فعلی خود را باقی دارید. آیا از ادامه خرید این پلن مطمئن هستید؟`
    : "آیا از ادامه خرید این پلن مطمئن هستید؟";
  // ------------------------------------------------------------------

  // ---------- Low Balance Modal (وقتی موجودی کمتر از حد آستانه‌ست) ----------
  const [lowBalanceModal, setLowBalanceModal] = useState({
    show: false,
    type: null, // 'direct' | 'wallet'
  });

  const closeLowBalanceModal = () => {
    setLowBalanceModal({ show: false, type: null });
    document.body.classList.remove("modal-opened");
  };

  const goToWallet = () => {
    closeLowBalanceModal();
    navigate("/wallet"); // ⚠️ مسیر واقعی صفحه کیف پول رو اینجا بذار
  };

  // کاربر با وجود موجودی کم، باز هم می‌خواد بخره
  const handleBuyAnyway = () => {
    const type = lowBalanceModal.type;
    closeLowBalanceModal();
    runPaymentByType(type);
  };

  const lowBalanceDescription = hasRemainingPlan
    ? `شما هنوز ${remainingDays.toLocaleString(
        "fa",
      )} روز از اشتراک‌تان باقی مانده است، در حالی که موجودی کیف پولتان کم است. الان نیازی به خرید اشتراک جدید ندارید؛ بهتر است کیف پول خود را شارژ کنید تا از امکانات سایت استفاده کنید.`
    : "برای استفاده از امکانات سایت، موجودی کیف پول شما کم است. لطفاً ابتدا کیف پول خود را شارژ کنید.";
  // ------------------------------------------------------------------

  const payment = async () => {
    setClickedButton("direct");
    const data = await dispatch(
      await paymentToWallet(price, cookies.authToken, id, 1),
    );

    if (data) {
      setClickedButton(null);
      const developerPayload = `userId=${data?.urls[0].user_id}&plan_id=${id}&type=${1}&amount=${price}&invoice_id=${data?.urls[0].invoice_id}`;
      navigate("/payment-geteway", {
        state: {
          urls: data?.urls,
          bazaar: {
            last_purchase_token,
            last_purchase_date,
            developerPayload,
            transaction_id: data?.urls[0].transaction_id,
            plan_code,
            wallet: false,
          },
          plan: {
            title,
            price,
          },
        },
      });
    }
  };

  const paymentWithWallet = async () => {
    if (!walletAmount || !price) return;
    setShowMessage(true);
    document.body.classList.add("modal-opened");
    if (Number(walletAmount) >= Number(price)) {
      setPaymentWithWalletStatusBalance(true);
      setTimeout(() => {
        navigate(location.pathname);
      }, 1000);
    } else {
      setPaymentWithWalletStatusBalance(false);
    }
  };

  // هندلر مشترک برای هر دو دکمه «مستقیم» و «کیف پول»
  const handlePaymentClick = (type) => {
    if (isLowBalance) {
      setLowBalanceModal({ show: true, type });
      document.body.classList.add("modal-opened");
      return;
    }

    setConfirmModal({ show: true, type });
    document.body.classList.add("modal-opened");
  };

  return (
    <>
      <div className="flex flex-row items-start 5xm:flex-nowrap flex-wrap justify-around gap-y-3">
        <PlanItemPaymentItem
          icon="peyment-card"
          text={clickedButton !== "direct" ? "مستقیم" : "loading"}
          click={() => handlePaymentClick("direct")}
          clickedButton={clickedButton}
        />
        {!hasBazaarSDK && (
          <PlanItemPaymentItem
            icon="wallet-2"
            text="کیف پول"
            click={() => handlePaymentClick("wallet")}
            clickedButton={clickedButton}
          />
        )}
      </div>

      {/* مودال تایید عادی (موجودی مشکلی نداره) */}
      <ConfirmModal
        show={confirmModal.show}
        setShow={(val) => setConfirmModal((prev) => ({ ...prev, show: val }))}
        title="تایید خرید"
        description={confirmDescription}
        onConfirm={handleGeneralConfirm}
        buttonConfirmText="تایید و ادامه"
        buttonCancelText="انصراف"
      >
        <div className="w-14 h-14 bg-white shadow-custom-lg flex items-center justify-center rounded-2xl text-yellow-600">
          <ReactSVG
            src={`${process.env.PUBLIC_URL}/assets/images/icons/wallet-money.svg`}
            className="w-10 h-10"
          />
        </div>
      </ConfirmModal>

      {/* مودال موجودی کم کیف پول */}
      <ConfirmModal
        show={lowBalanceModal.show && !hasBazaarSDK}
        setShow={(val) =>
          setLowBalanceModal((prev) => ({ ...prev, show: val }))
        }
        title="موجودی کیف پول کم است"
        description={lowBalanceDescription}
        onConfirm={goToWallet}
        buttonConfirmText="شارژ کیف پول"
        buttonCancelText="انصراف"
        onSecondary={handleBuyAnyway}
        buttonSecondaryText="نه، همینطوری خرید کن"
      >
        <div className="w-14 h-14 bg-white shadow-custom-lg flex items-center justify-center rounded-2xl text-yellow-600">
          <ReactSVG
            src={`${process.env.PUBLIC_URL}/assets/images/icons/wallet-money.svg`}
            className="w-10 h-10"
          />
        </div>
      </ConfirmModal>

      <MessageForPaymentWallet
        status={paymentWithWalletStatusBalance}
        showMessage={showMessage}
        onSetShowMessage={setShowMessage}
        onToggleActivePaymentItem={onToggleActivePaymentItem}
        planId={id}
        planPrice={price}
        balance={walletAmount}
      />
    </>
  );
};

export default PlanItemPaymentItems;
